"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hexDocs = void 0;
var hexDocs = exports.hexDocs = {
  name: 'hex',
  category: 'Utils',
  syntax: ['hex(value)'],
  description: 'Format a number as hexadecimal',
  examples: ['hex(240)'],
  seealso: ['bin', 'oct']
};